import script from "./NotificationIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationIcon.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationIcon.vue?vue&type=style&index=0&id=76dd3300&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76dd3300"]])

export default __exports__